<template>
  <div class="week-single">
    <b-col cols="3" />
    <b-col
      v-if="question.id == 1 || question.type == 'modal'"
      align-self="center"
      class="d-flex flex-column"
    >
      <div class="tw-flex tw-flex-col tw-justify-start tw-max-w-[650px] tw-mx-auto tw-my-3">
        <h2 class="question-title-v2 mb-2 !tw-mt-0">
          {{ question.title }}
        </h2>
        <p class="sub-text">
          {{ question.question }}
        </p>
      </div>
      <div class="align-self-center">
        <button
          class="tw-my-5 tw-w-[300px] tw-rounded-lg tw-p-2 tw-uppercase tw-font-bold tw-tracking-[0.15rem] tw-bg-[#a783ff] tw-text-white"
          @click="submitAnswer(question.id, question.answerlist[0].id, question.answerlist[0])"
        >
          {{ question.answerlist[0].name }}
        </button>
        <div
          v-if="question.answerlist.length > 1"
          class="align-self-center mt-3 pt-1"
        >
          <a 
            href="javascript:void(0)" 
            class="text-default text-underline"
            @click="submitAnswer(question.id, question.answerlist[1].id, question.answerlist[1])"
          >
            {{ question.answerlist[1].name }}
          </a>
        </div>
      </div>
    </b-col>
    <b-col
      v-else
      align-self="center"
      class="d-flex flex-column"
    >
      <h1 class="text-center question-title-v2">
        {{ question.question }}
      </h1>
      <div class="text-center">
        <b-button
          v-for="(item, i) in question.answerlist"
          :id="item.name + question.id"
          :key="item.name + i"
          variant="outline-info"
          size="xl"
          :value="item.id"
          :pressed="item.id == lastAnswer.answer"
          class="mx-3 question-btn"
          :class="(item.id == lastAnswer.answer) ? 'active' : 'inactive'"
          @click="onSelect(item)"
        >
          {{ item.name }}
        </b-button>
      </div>
      <div class="text-center">
        <button
          v-if="question.hasOwnProperty('answer') && !composite"
          class="tw-my-5 tw-w-[300px] tw-rounded-lg tw-p-2 tw-uppercase tw-font-bold tw-tracking-[0.15rem] tw-bg-[#a783ff] tw-text-white"
          @click="
            submitAnswer(
              question.id,
              answer,
              question.answerlist.find((o) => o.id == answer)
            )
          "
        >
          Continue
        </button>
      </div>
    </b-col>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      default() {
        return {};
      },
    },
    lastAnswer: {
      type: Object,
      default() {
        return {};
      },
    },
    composite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      answer: null,
      answerSelected: {},
    };
  },
  computed: {
    allowEmpty(){
      return this.question.hasOwnProperty('allowempty')
        ? this.question.allowempty
        : true
    }
  },
  watch: {
    question: {
      handler: function() {
        this.answer = null;
        if (this.question.hasOwnProperty('answer')) {
          this.answer = this.question.answer;
        }
      },
      deep: true,
    },
    answerSelected: {
      handler: function() {
        this.allowEmpty && this.submitAnswer(this.question.id, this.answerSelected.id, this.answerSelected)
      },
      deep: true,
    },
  },
  mounted () {
    if (this.question.hasOwnProperty('answer')) {
      this.answer = this.question.answer
    } else {
      this.answer = 'undefined'
    }
  },
  methods: {
    submitAnswer(id, answer, answerBody) {
      this.answer = answer;
      this.$emit('submitAnswer', id, answer, answerBody);
    },
    onSelect(answer){
      this.answerSelected = answer
    },
  }
};
</script>

<style scoped>
@media screen and (max-width: 1024px) {
  .inactive:hover {
    background-color: transparent !important;
    color: #495057 !important;
    border-color: #bdbdbd !important;
  }
}
</style>
